import { ca } from '@cian/analytics';

export const trackSubmitClicked = (action: 'highway_save' | 'railway_save', savedCount: number) =>
  ca('event', {
    action,
    category: 'FilterPopup',
    label: savedCount.toString(),
    name: 'oldevent',
  });
